import { z } from 'zod';

import { TransactionSchema } from './claim';

export const CreateClaimReversalRequestSchema = z.object({
  ProviderMessage: z.object({
    Reversal: z.object({
      Transaction: TransactionSchema,
    }),
  }),
});

export type CreateClaimReversalRequest = z.infer<
  typeof CreateClaimReversalRequestSchema
>;

const CreateClaimReversalErrorSchema = z.object({
  objectName: z.string(),
  field: z.string(),
  rejectedValue: z.string(),
  codes: z.string().array(),
  defaultMessage: z.string(),
  code: z.string(),
});

export type CreateClaimReversalError = z.infer<
  typeof CreateClaimReversalErrorSchema
>;

export const CreateClaimReversalErrorResponseSchema = z.object({
  Message: z.string(),
  Errors: CreateClaimReversalErrorSchema.array(),
});

export type CreateClaimReversalErrorResponse = z.infer<
  typeof CreateClaimReversalErrorResponseSchema
>;

export const CreateClaimReversalSuccessResponseSchema = z.object({
  MessageId: z.string(),
  Message: z.string(),
  InvoiceNum: z.string(),
});
export type CreateClaimReversalSuccessResponse = z.infer<
  typeof CreateClaimReversalSuccessResponseSchema
>;

export const CreateClaimReversalResponseSchema = z.union([
  CreateClaimReversalSuccessResponseSchema,
  CreateClaimReversalErrorResponseSchema,
]);

export type CreateClaimReversalResponse = z.infer<
  typeof CreateClaimReversalResponseSchema
>;
